import { withNamespaces } from "react-i18next"
import { Alert, Badge, Card, CardBody, CardHeader } from "reactstrap";

const ComplianceBlockers = ({ t, complianceQuery }) => {
    if (complianceQuery.isFetching) return null;

    const {
        orchestration
    } = complianceQuery.data?.data || {};

    const blockers = orchestration?.decisionSupport?.unresolvedBlockers || [];
    
    if (!blockers.length) return null;

    return (
        <Card className="mb-4">
            <CardHeader>
                <h5 className="mb-0">
                    {t('Unresolved Blockers')}
                </h5>
            </CardHeader>

            <CardBody>
                {blockers.map(blocker => (
                    <Alert
                        color="danger"
                        key={blocker.id}
                    >
                        <div className="d-flex justify-content-between">
                            <strong>
                                {t(blocker.title)}
                            </strong>

                            <Badge className="bg-danger" color="danger">
                                {t(blocker.severity)}
                            </Badge>
                        </div>

                        <div className="mt-2">
                            {t(blocker.detail)}
                        </div>
                    </Alert>
                ))}
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    ComplianceBlockers
);